exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".app-loading {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -54px;\n    margin-left: -54px;\n    width: 108px !important;\n    height: 108px !important;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader!./src/styles.css
// module id = 809
// module chunks = 2